import { createBrowserRouter } from 'react-router-dom';
import DirectMessage from '../components/pageComponents/Message/DirectMessage';
import Force2UpdateProfile from '../components/pageComponents/MyTeam/Force2UpdateProfile';
import PhysicalData from '../components/pageComponents/Profile/PhysicalData.jsx';
import { ErrorBoundaries } from '../components/reusable/ErrorBoundaries';
import AccountSettings from '../pages/account/AccountSetting.jsx';
import BlockUsers from '../pages/account/BlockUsers.jsx';
import AccountSetup from '../pages/AccountSetup/Page.jsx';
import AllResults from '../pages/AllResults';
import AllResultSeason from '../pages/AllResultSeason';
import AnnoucementPage from '../pages/AnnoucementPage.jsx';
import ClubSelect from '../pages/ClubSelect';
import ClubTeams from '../pages/ClubTeams';
import Comments from '../pages/Comments';
import PrivacyPolicy from '../pages/condtions/PrivacyPolicy.jsx';
import TermsAndConditions from '../pages/condtions/TermsAndCondition.jsx';
import Connections from '../pages/Connections';
import CreateProfile from '../pages/CreateProfile';
import EditHighlight from '../pages/EditHighlight';
import EditHighlights from '../pages/EditHighlights';
import EditProfile from '../pages/EditProfile';
import Homepage from '../pages/Homepage';
import LeagueAndStats from '../pages/LeagueAndStats';
import LeagueTopApperances from '../pages/LeagueTopApperances';
import LeagueTopAssists from '../pages/LeagueTopAssists';
import LeagueTopCleanSheets from '../pages/LeagueTopCLeanSheets';
import LeagueTopScorer from '../pages/LeagueTopScorer';
import Login from '../pages/Login';
import MessageList from '../pages/MessageList';
import MyTeam from '../pages/MyTeam';
import MyTeamResultDetails from '../pages/MyTeamResultDetails';
import MyTeamResultDetailsHighlights from '../pages/MyTeamResultDetailsHighlights';
import MyTeamResultDetailsLineups from '../pages/MyTeamResultDetailsLineups';
import NewMessage from '../pages/NewMessage.jsx';
import Onboarding from '../pages/Onboarding.jsx';
import Players from '../pages/Players';
import Profile from '../pages/Profile';
import References from '../pages/References.jsx';
import ReferencesFormPage from '../pages/ReferencesFormPage.jsx';
import Result from '../pages/Result';
import SearchUser from '../pages/SearchUser';
import SecuritySetting from '../pages/SecuritySetting';
import Settings from '../pages/Settings';
import ShareFeed from '../pages/ShareFeed';
import Signup from '../pages/Signup';
import TeamSelect from '../pages/TeamSelect';
import TopApperances from '../pages/TopApperances';
import TopAssists from '../pages/TopAssists';
import TopCleanSheets from '../pages/TopCLeanSheets';
import TopScorer from '../pages/TopScorer';
import UploadFeed from '../pages/UploadFeed';
import AuthRoute from './auth';
import PrivateRoute from './private';
import PrivacyAndSecurity from '../pages/account/PrivacyAndSecurity.jsx';
import MobileRedirect from '../pages/MobileRedirect.jsx';
import PrivateRouteWithPlaceholder from './privateWithPlaceholder.jsx';
import ContractSelect from '../pages/ContractSelect.jsx';
import WorkStatus from '../pages/WorkStatus.jsx';

const MOBILE_REDIRECT_PAGES = [
    'featured-players',
    'opportunities/*',
    'noticeboard'
];

export const router = createBrowserRouter([
    {
        path: '*',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <Homepage />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <Homepage />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/terms',
        element: (
            <ErrorBoundaries>
                <TermsAndConditions />
            </ErrorBoundaries>
        )
    },
    {
        path: '/privacy-policy',
        element: (
            <ErrorBoundaries>
                <PrivacyPolicy />
            </ErrorBoundaries>
        )
    },
    {
        path: '/login',
        element: (
            <AuthRoute
                element={
                    <ErrorBoundaries>
                        <Login />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/signup1',
        element: (
            <AuthRoute
                element={
                    <ErrorBoundaries>
                        <Signup />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/signup',
        element: (
            <AuthRoute
                element={
                    <ErrorBoundaries>
                        <Onboarding />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/account-setup',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <AccountSetup />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/create-profile',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <CreateProfile />
                    </ErrorBoundaries>
                }
            />
        )
    },

    {
        path: '/club-select',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <ClubSelect />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/contract-select',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <ContractSelect />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/work-status',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <WorkStatus />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/team-dashboard',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <MyTeam />
                    </ErrorBoundaries>
                }
            />
        )
    },

    {
        path: '/team-dashboard/result-details',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <MyTeamResultDetails />
                    </ErrorBoundaries>
                }
            />
        )
    },

    {
        path: '/reference/:toUserId',
        element: (
            <PrivateRouteWithPlaceholder
                element={
                    <ErrorBoundaries>
                        <References />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/reference/form/:toUserId',
        element: (
            <ErrorBoundaries>
                <ReferencesFormPage />
            </ErrorBoundaries>
        )
    },
    {
        path: '/team-dashboard/result-details/lineups',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <MyTeamResultDetailsLineups />
                    </ErrorBoundaries>
                }
            />
        )
    },

    {
        path: '/team-dashboard/result-details/highlights',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <MyTeamResultDetailsHighlights />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/upload-feed',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <UploadFeed />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/profile',
        element: (
            <PrivateRouteWithPlaceholder
                element={
                    <ErrorBoundaries>
                        <Profile />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/profile/physical',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <PhysicalData />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/league-and-stats',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <LeagueAndStats />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/league-top-scorer',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <LeagueTopScorer />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/league-top-assists',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <LeagueTopAssists />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/league-top-clean-cheets',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <LeagueTopCleanSheets />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/league-top-apperances',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <LeagueTopApperances />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/top-scorer',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <TopScorer />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/top-assists',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <TopAssists />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/top-clean-sheets',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <TopCleanSheets />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/top-apperances',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <TopApperances />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/all-results',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <AllResults />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/all-results/season',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <AllResultSeason />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/team-dashboard/result-details/edit-highlights',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <EditHighlights />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/team-dashboard/result-details/edit-highlight',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <EditHighlight />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/players',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <Players />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/club-teams',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <ClubTeams />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/team-select',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <TeamSelect />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/edit-profile',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <EditProfile />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/no-club-error',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <Force2UpdateProfile />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/settings',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <Settings />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/settings/security',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <SecuritySetting />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/settings/account',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <AccountSettings />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/settings/account/blocked-users',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <BlockUsers />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/settings/account/privacy-and-security',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <PrivacyAndSecurity />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/user/comment',
        element: (
            <PrivateRouteWithPlaceholder
                element={
                    <ErrorBoundaries>
                        <Comments />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/user/announcement',
        element: (
            <PrivateRouteWithPlaceholder
                element={
                    <ErrorBoundaries>
                        <AnnoucementPage />
                    </ErrorBoundaries>
                }
            />
        )
    },

    {
        path: '/user/search',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <SearchUser />
                    </ErrorBoundaries>
                }
            />
        )
    },

    {
        path: '/user/message',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <DirectMessage />
                    </ErrorBoundaries>
                }
            />
        )
    },

    {
        path: '/user/new-message',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <NewMessage />
                    </ErrorBoundaries>
                }
            />
        )
    },

    {
        path: '/user/message-list',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <MessageList />
                    </ErrorBoundaries>
                }
            />
        )
    },

    {
        path: '/user/connections',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <Connections />
                    </ErrorBoundaries>
                }
            />
        )
    },

    {
        path: '/feed/share',
        element: (
            <PrivateRouteWithPlaceholder
                element={
                    <ErrorBoundaries>
                        <ShareFeed />
                    </ErrorBoundaries>
                }
            />
        )
    },
    {
        path: '/feed/result',
        element: (
            <PrivateRoute
                element={
                    <ErrorBoundaries>
                        <Result />
                    </ErrorBoundaries>
                }
            />
        )
    },
    ...MOBILE_REDIRECT_PAGES.map(page => ({
        path: `/${page}`,
        element: (
            <ErrorBoundaries>
                <MobileRedirect page={page} />
            </ErrorBoundaries>
        )
    }))
]);
